module.exports = "/_next/static/images/39fffdb518d29acc12c68e4b5a365af2-dst.png.webp";